import { CodeListItemWire } from 'app/area/import-mappings/types';
import { CodeListItem, ImportMappingType } from './types-store';

export const mapListToStore = (
  codetableId: number,
  codeItems: CodeListItemWire[]
): CodeListItem[] => (codeItems
  ?.map(item => ({
    codetableId,
    id: item.code && item.code.v,
    description: item.code && item.code.d,
    disabled: item?.disabled,
    childrenCount: item.descendantCount || 0,
    ...(item.category && ({
      category: {
        value: item.category.v,
        description: item.category.d
      }
    })),
    importMapping: item.importMapping.map(mapping => {
      return {
        importNumber: mapping.importNumber,
        externalValue: mapping.externalValue,
        existingExternalValue: mapping.externalValue,
        type: ImportMappingType.Init
      };
    })
  })) || [] as CodeListItem[]);
